import React, { useState } from "react";
import "./footer.css";

import logo from "../../assets/logo-light.png";
import { PrivacyModal, UseTermsModal } from "..";

import instagram from "../../assets/social-icons/instagram.svg";
import youtube from "../../assets/social-icons/youtube.svg";

const SOCIAL_MEDIA = [
  {
    name: "instagram",
    icon: instagram,
    link: "https://www.instagram.com/orion_sinais/",
  },
  {
    name: "youtube",
    icon: youtube,
    link: "https://www.youtube.com/@orionsinais",
  },
];

function Footer() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showUseTermsModal, setShowUseTermsModal] = useState(false);

  return (
    <div className="orion__footer">
      <div className="orion__footer-section">
        <img className="orion__footer-logo" src={logo} alt="Orion logo" />
        <div className="orion__footer-message-wrapper">
          <div className="orion__footer-message-policy">
            <small
              className="orion__footer-link"
              onClick={() => setShowUseTermsModal(true)}
            >
              Termos de Uso
            </small>
            <small>|</small>
            <small
              className="orion__footer-link"
              onClick={() => setShowPrivacyModal(true)}
            >
              Política de Privacidade
            </small>
          </div>
          <small className="orion__footer-message">
            Feito com ♥ em São Paulo por Cryptolovers
          </small>
        </div>
      </div>
      <div className="orion__footer-section">
        <div className="orion__social-container">
          {SOCIAL_MEDIA.map((social, index) => (
            <a
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={social.icon}
                alt={`Link para a rede social ${social.name} da Orion Sinais`}
              />
            </a>
          ))}
        </div>
        <div className="orion__contact-info">
          <small>contato@orionsinais.com.br</small>
          <small>
            Av. Paulista, nº 1636 – Conjunto 4 – Pav. 1504 - São Paulo
          </small>
        </div>
      </div>
      {showPrivacyModal && <PrivacyModal setOpenModal={setShowPrivacyModal} />}
      {showUseTermsModal && (
        <UseTermsModal setOpenModal={setShowUseTermsModal} />
      )}
    </div>
  );
}

export default Footer;
